module.exports = __webpack_public_path__ + "img/daily_necessities_laundry.ce50d9ff.jpg";